module.exports = __webpack_public_path__ + "static/20-purple-5fff648260106a784bee3c133d42cf20.jpg";